export default "__VITE_ASSET__258d7e21__"